import React from 'react';

const PermissionWrapper = ({ user, required, children, mode = 'every', fallback = null }) => {
 if (!user) return fallback;

 const role = (user.role?.name || user.roleName || "").toLowerCase();

 // Admin bypass
 if (role === 'admin') {
 return <>{children}</>;
 }

 if (!user.permissionNames) return fallback;

 // Normalize helper
 const normalize = (str) => (str || "").toLowerCase().replace(/[:\s_-]/g, "");
 const userPerms = user.permissionNames.map(p => normalize(p));

 const hasPermission = mode === 'some' 
 ? required.some(req => {
 const normReq = normalize(req);
 return userPerms.includes(normReq);
 })
 : required.every(req => {
 const normReq = normalize(req);
 return userPerms.includes(normReq);
 });

 return hasPermission ? <>{children}</> : fallback;
};

export default PermissionWrapper;
